import { actionsFactory, props } from '@ngneat/effects';

import { AuthConfig, AuthErrorMap, AuthTextMap } from '../models/auth-config';
import { AuthErrorType } from '../models/auth-error-type';
import { AuthState } from '../models/auth-state';

const authActions = actionsFactory('@tmx/auth');

export const setAuthConfig = authActions.create(
  'Set Auth Config',
  props<{ authConfig: AuthConfig }>()
);

export const setAuthTextMap = authActions.create(
  'Set Auth Text Map',
  props<{ authTextMap: AuthTextMap }>()
);

export const setAuthErrorMap = authActions.create(
  'Set Auth Error Map',
  props<{ authErrorMap: AuthErrorMap }>()
);

export const checkUsernameExists = authActions.create(
  'Check Username Exists',
  props<{ email: string }>()
);

export const setAuthErrorMessage = authActions.create(
  'Set Auth Error Message',
  props<{
    errorType: AuthErrorType | null;
  }>()
);

export const redirectUserToTid = authActions.create(
  'Redirect User To TID',
  props<{ skipLoginPage?: boolean; username?: string }>()
);

export const setAuthCode = authActions.create(
  'Set Auth Code',
  props<{ authCode: null | string }>()
);

export const authenticateUser = authActions.create(
  'Authenticate User',
  props<{ account?: string; authCode: string }>()
);

export const setAuthState = authActions.create(
  'Set Auth State',
  props<{ authState: AuthState }>()
);

export const fetchJwt = authActions.create(
  'Fetch JWT',
  props<{ authenticationToken: string }>()
);

export const verifyAuthSession = authActions.create(
  'Verify Auth Session',
  props<{ appName: string }>()
);

export const switchAccounts = authActions.create(
  'Switch Accounts',
  props<{ alias: string; authToken: string; product: string }>()
);

export const fetchSwitchedJwt = authActions.create(
  'Fetch Switched JWT',
  props<{ targetAccountId: number }>()
);

export const logoutUser = authActions.create('Log Out User');

export const clearAuthSession = authActions.create('Clear Auth Session');
